module.exports = __webpack_public_path__ + "img/two.2fb76319.png";